const CustomerStore = {
    state: {
        corporation: null,
        customer: {},
        settings: {},
        billingSettings: {},
        billingAddress: {
            line1: null,
            line2: null,
            postalCode: null,
            city: null,
            state: null,
            country: null,
            saasThirdPartyPayerAddressId: null,
        },
        accounts: [],
        subscribedProducts: [],
        creditCard: false,
        stripeToken: false,
    },
    mutations: {
        setCorporation(state, data) {
            state.corporation = data;
        },
        setCustomer(state, data) {
            state.customer = data;
        },
        setBillingSettings(state, data) {
            state.billingSettings = data;
        },
        setSettings(state, data) {
            state.settings = data;
        },
        setBillingAddress(state, data) {
            state.billingAddress = data;
        },
        setAccounts(state, data) {
            state.accounts = data;
        },
        setSubscribedProducts(state, data) {
            state.subscribedProducts = data;
        },
        setCreditCard(state, data) {
            state.creditCard = data;
        },
        setStripeToken(state, token) {
            state.stripeToken = token;
        },
    },
    actions: {
        defineCorporation({ commit }, value) {
            commit('setCorporation', value);
        },
        defineCustomer({ commit }, value) {
            commit('setCustomer', value);
        },
        defineCustomerBillingSettings({ commit }, value) {
            commit('setBillingSettings', value);
        },
        defineCustomerSettings({ commit }, value) {
            commit('setSettings', value);
        },
        defineCustomerBillingAddress({ commit }, value) {
            commit('setBillingAddress', value);
        },
        defineCustomerAccounts({ commit }, value) {
            commit('setAccounts', value);
        },
        defineCustomerSubscribedProducts({ commit }, value) {
            commit('setSubscribedProducts', value);
        },
        defineCustomerCreditCard({ commit }, value) {
            commit('setCreditCard', value);
        },
        defineCustomerStripeToken({ commit }, value) {
            commit('setStripeToken', value);
        },
    },
    getters: {
        customer: (state) => state.customer,
        corporation: (state) => state.corporation,
        customerBillingSettings: (state) => state.billingSettings,
        customerSettings: (state) => state.settings,
        customerBillingAddress: (state) => state.billingAddress,
        customerAccounts: (state) => state.accounts,
        customerSubscribedProducts: (state) => state.subscribedProducts,
        customerCreditCard: (state) => {
            if (state.creditCard === false) return false;
            state.creditCard.expireDate =
                state.creditCard.expMonth +
                '/' +
                state.creditCard.expYear.toString().substring(2, 4);
            return state.creditCard;
        },
        stripeToken: (state) => state.stripeToken,
    },
};

export default CustomerStore;
